import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeId = "dark-neon" | "midnight" | "light";

interface SettingsState {
  modelId: string;
  maxSteps: number;
  theme: ThemeId;

  setModelId: (modelId: string) => void;
  setMaxSteps: (maxSteps: number) => void;
  setTheme: (theme: ThemeId) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      modelId: "KIMI_K2_THINKING",
      maxSteps: 100,
      theme: "light" as ThemeId,

      setModelId: (modelId) => set({ modelId }),
      setMaxSteps: (maxSteps) => set({ maxSteps }),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: "cai-settings",
      storage: {
        getItem: (name) => {
          const value = localStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) =>
          localStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => localStorage.removeItem(name),
      },
    }
  )
);
